module.exports = __webpack_public_path__ + "img/firstStepSelected.dcd4c551.png";